export default {
  "navInfo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nav info"])},
  "topNav": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Top nav"])}
}